import * as React from 'react';
import Section from '../components/Section';

import { Image, Row, Col, Card, Statistic } from 'antd'; 

import brygge from './media/brygge.jpg';

export default function Boats() {

    var prices = (
        <Card title="Prisar" bordered={false}>
            <Row gutter={[32, 32]}>
                <Col xs={12}  lg={4}><Statistic title="Robåt per time" value="80,-" /></Col>
                <Col xs={12}  lg={4}><Statistic title="Trøbåt per time" value="80,-" /></Col>
                <Col xs={12} lg={4}><Statistic title="Kano per time" value="80,-" /></Col>
                <Col xs={12} lg={4}><Statistic title="Motorbåt per time" value="140,-" /></Col>
                <Col xs={24} lg={8}><Statistic title="Motorbåt per dag" value="400,-" suffix="+ bensin" /></Col>
            </Row>
        </Card>
    );

    return (
        <Section id="boats" title="Båtutleige">
            <Image src={brygge} preview={false} width="100%" style={{ marginBottom: "16px" }} />
            <p>På Nesjartun har du mulighet til å leige båt på Hornindalsvatnet. Vi har motorbåtar, robåt, trøbåt og kano.</p>
            {prices}
        </Section>
    );
}